<template>
  <div>
    <div
      v-if="component.controlName === 'labelValue'"
      :class="[component.customClass, 'form-control']"
    >
      <v-layout align-start justify-start row>
        <v-flex lg6>
          <span>{{ displayName }}</span>
        </v-flex>
        <v-flex lg6>
          <span>{{ component.defaultValue }}</span>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="component.controlName === 'groupTitle'"
      :class="[component.customClass, 'form-control inner-group']"
    >
      <div class="group-title">{{ displayName }}:</div>
    </div>
    <div
      v-if="component.controlName === 'labelString' &&
        component.defaultValue"
      :class="[component.customClass, 'form-control']"
    >
      <v-layout align-start justify-start row mb-6>
        <v-flex lg4>
          <span>{{ displayName }}:</span>
        </v-flex>
        <v-flex lg6>
          <span>{{ component.defaultValue }}</span>
        </v-flex>
        <v-flex lg2 text-right v-if="component.defaultValue">
          <v-btn
            class="delete-btn"
            :ripple="false"
            text
            icon
            color="#DC3828"
            small
            :autoid="component.inlineIconBtn.autoid"
            @click="
                handle_function_call(component.inlineIconBtn.actionMethod)
              "
          >
            <v-icon>{{ component.inlineIconBtn.iconName }}</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-else-if="component.controlName === 'label'"
      :class="[component.customClass, 'form-control']"
    >
      <div>{{ displayName }}</div>
      <template v-for="(labels, index) in component.options">
        <v-layout
          align-start
          justify-start
          row
          :key="index"
          class="rowDisplayData"
          v-if="labels.defaultValue === true"
        >
          <span>{{ labels.displayName }}</span>
        </v-layout>
      </template>
    </div>
    <div
      v-else-if="component.controlName === 'subTitle'"
      :class="[component.customClass, 'form-control']"
    >
      <div v-if="component.show !== false">{{ displayName }}</div>
    </div>
    <div
      v-else-if="component.controlName === 'input'"
      :class="[component.customClass, 'form-control']"
    >
      <v-text-field
        v-if="component.show !== false"
        autocomplete="new-password"
        v-model="component.defaultValue"
        :label="displayName"
        :type="component.type"
        :disabled="(() => { return isInputDisabled(component)})()"
        outlined
        color="gray darken-4"
        :hint="(() => { return showHintText(component)})()"
        persistent-hint
        :autoid="component.autoid"
        v-validate="component.validationRule"
        :data-vv-as="displayName"
        :data-vv-name="component.key"
        :key="component.key"
        data-vv-validate-on="change"
        :error-messages="errors.collect(component.key)"
        :prefix="component.prefixValue"
        :ref="component.refId"
      ></v-text-field>
    </div>
    <!-- Hidden Input -->
    <div
      v-else-if="component.controlName === 'inputHidden'"
      :class="[component.customClass, 'form-control']"
    >
      <v-text-field
        v-show="false"
        autocomplete="new-password"
        v-model="component.defaultValue"
        :label="displayName"
        :type="component.type"
        color="gray darken-4"
        :autoid="component.autoid"
        :key="component.key"
        :prefix="component.prefixValue"
        :ref="component.refId"
      ></v-text-field>
    </div>
    <!-- Hidden Input -->
    <!-- Hidden Toggle -->
    <div
      v-else-if="component.controlName === 'toggleHidden'"
      :class="[component.customClass, 'form-control']"
    >
        <v-switch
            v-show="false"
            v-model="component.defaultValue"
            :autoid="component.autoid"
            :label="displayName"
            inset
            :class="[component.customClass, 'test rightAlignSwitch outlined']"
        ></v-switch>
    </div>
    <!-- Hidden Toggle -->
    <div
      v-else-if="component.controlName === 'resetButton' && 
      isEditFlow && 
      (() => { return isResetVisible(component)})() &&
      component.show !== false"
      :class="[component.customClass, 'form-control']"
    >
      <v-row no-gutters>
        <v-col cols="12" md="4" lg="4" offset-md="8" offset-lg="8" class="text-right">
          <v-btn
            :color="component.actionType"
            :outlined="component.outlined"
            depressed
            small
            :autoid="component.autoid"
            :hint="component.editHintText"
            :disabled="component.defaultValue"
            @click="handle_function_call(component.actionMethod, $event)"
          >{{ component.displayName }}</v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="8" lg="8" offset-md="4" offset-lg="4">
          <span class="hint-text">{{ component.editHintText }}</span>
        </v-col>
      </v-row>
    </div>
    <div
      v-else-if="component.controlName === 'textArea'"
      :class="[component.customClass, 'form-control']"
    >
      <v-textarea
        v-if="component.show !== false"
        autocomplete="new-password"
        v-model="component.defaultValue"
        :label="displayName"
        :hint="component.hintText"
        persistent-hint
        outlined
        :autoid="component.autoid"
        v-validate="component.validationRule"
        :data-vv-as="displayName"
        :data-vv-name="component.key"
        :key="component.key"
        data-vv-validate-on="change"
        :error-messages="errors.collect(component.key)"
      ></v-textarea>
    </div>
    <div
      v-else-if="component.controlName === 'select'"
      :class="[component.customClass, 'form-control']"
    >
      <v-select class="form-control" :items="component.options" :label="displayName" outlined></v-select>
    </div>
    <div
      v-else-if="component.controlName === 'radioGroup'"
      :class="[component.customClass, 'form-control', 'radio-group-ctr']"
    >
      <div class="group-title">{{ displayName }}:</div>
      <v-radio-group v-model="component.defaultValue" row>
        <v-radio
          v-for="(radios, index) in component.options"
          :key="index"
          :label="radios.displayName"
          :value="radios.value"
          :autoid="radios.autoid"
        ></v-radio>
      </v-radio-group>
    </div>
    <div
      v-else-if="component.controlName === 'checkboxGroup' && component.show != false"
      :class="[component.customClass, 'form-control', 'checkbox-group-ctr']"
    >
      <div class="group-title">{{ displayName }}:</div>
      <v-layout row>
        <template v-for="(checkboxs, index) in component.options">
          <v-checkbox
            v-model="component.defaultValue"
            v-if="checkboxs.show != false"
            :label="checkboxs.displayName"
            :value="checkboxs.value"
            :autoid="checkboxs.autoid"
            :disabled="checkboxs.disabled"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            class="outlined"
            v-validate="component.validationRule"
            :data-vv-name="component.validationName"
            data-vv-validate-on="change"
            :error-messages="errors.collect(component.validationName)"
            :hide-details="index !== 0"
            :key="index"
            @change="component.channelConfig ? updateChannelComponent(component) : updateComponent(component)"
          ></v-checkbox>
        </template>
      </v-layout>
    </div>
    <div
      v-else-if="component.controlName === 'checkbox'"
      :class="[component.customClass, 'form-control']"
    >
      <v-checkbox
        v-model="component.defaultValue"
        :autoid="component.autoid"
        :label="displayName"
        :disabled="component.disabled"
      ></v-checkbox>
    </div>
    <div
      v-else-if="component.controlName === 'files'"
      :class="[component.customClass, 'form-control']"
    >
      <div v-if="component.refId === 'samlCertprod'">
        <yFileUploaderProd :fileUploadProps="component"/>
      </div>
      <div v-else>
        <yFileUploaderDev :fileUploadProps="component"/>
      </div>
    </div>
    <div
      v-else-if="component.controlName === 'addListItem'"
      :class="[component.customClass, 'form-control']"
    >
      <yAddListItem :dataListProps="component"></yAddListItem>
    </div>
    <div
      v-else-if="component.controlName === 'link'"
      :class="[component.customClass, 'form-control']"
    >
      <v-btn text small color="primary">
        <v-icon left>{{ component.iconName }}</v-icon>
        {{ displayName }}
      </v-btn>
    </div>
    <div
      v-else-if="component.controlName === 'button'"
      :class="[component.customClass, 'form-control']"
    >
      <v-btn
        color="primary"
        :outlined="component.outlined"
        :disabled="component.disabled"
        :autoid="component.autoid"
        :class="[(component.show === false) ? 'd-none' : '']"
        @click="handle_function_call(component.actionMethod)"
      >
        <v-icon left>{{ component.iconName }}</v-icon>
        {{ displayName }}
      </v-btn>
    </div>
    <div v-else-if="component.controlName === 'formGroup'" class="form-group-ctr clearfix">
      <div v-if="component.show !== false">
        <div class="group-title form-control" v-if="component.inlineIconBtn">
          <v-row>
            <v-col align-self="center">
              <span>{{ component.displayName }}:</span>
              <span style="float: right">
                <v-btn
                  class="delete-btn"
                  :ripple="false"
                  text
                  icon
                  color="#DC3828"
                  small
                  :autoid="component.inlineIconBtn.autoid"
                  @click="
                      handle_function_call(component.inlineIconBtn.actionMethod)
                    "
                >
                  <v-icon
                    v-if="component.inlineIconBtn.show !== false"
                  >{{ component.inlineIconBtn.iconName }}</v-icon>
                </v-btn>
              </span>
            </v-col>
          </v-row>
        </div>
        <div class="group-title" v-else>{{ component.displayName }}:</div>
        <div v-for="(component, index) in component.formData" :key="index">
          <conditional-render :dataProps="component"/>
        </div>
      </div>
    </div>
    <div
      v-else-if="component.controlName === 'productGroup' && component.show !== false"
      :class="[component.customClass, 'form-control', 'product-group-ctr']"
    >
      <v-checkbox
        v-model="component.defaultValue"
        :autoid="component.autoid"
        class="product-group-checkbox outlined"
        on-icon="check_box"
        off-icon="check_box_outline_blank"
        :ref="component.refId"
        :key="component.key"
        :disabled="component.disabled"
      >
        <template v-slot:label>
          <div v-if="isCDVEnabled">
            {{displayName}}
            <span class="chkbox-subLabel">with matching service</span>
          </div>
          <div v-else>{{displayName}}</div>
        </template>
      </v-checkbox>
      <div v-if="component.show !== false">
        <div
          v-for="(subComponent, index) in component.formData"
          :key="index"
          class="form-data"
          v-if="subComponent.show !== false"
        >
          <div v-if="subComponent.show !== false && subComponent.controlName !== 'toggleHidden'">
            <v-switch
              v-model="subComponent.defaultValue"
              :autoid="subComponent.autoid"
              :label="subComponent.displayName"
              :disabled="!component.defaultValue"
              inset
              :class="[subComponent.customClass, 'rightAlignSwitch outlined']"
            ></v-switch>
            
            <div
                v-for="(childComponent, index) in subComponent.formData"
                :key="index"
                class="form-data"
                v-if="childComponent.show !== false"
                >
                <div
                    v-if="childComponent.controlName === 'input'"
                    :class="[childComponent.customClass]"
                >
                    <v-text-field
                    v-model="childComponent.defaultValue"
                    :label="childComponent.displayName"
                    :type="childComponent.type"
                    outlined
                    color="gray darken-4"
                    :class="[subComponent.defaultValue ? 'show' : 'hide', 'rightAlignInput']"
                    :autoid="childComponent.autoid"
                    v-validate="component.defaultValue && subComponent.defaultValue ? childComponent.validationRule : ''"
                    :data-vv-as="childComponent.displayName"
                    :data-vv-name="childComponent.key"
                    :key="childComponent.key"
                    data-vv-validate-on="change"
                    :error-messages="errors.collect(childComponent.key)"
                    :prefix="childComponent.prefixValue"
                    :ref="childComponent.refId"
                    :hint="childComponent.hintText"
                    persistent-hint
                    :disabled="!component.defaultValue || !subComponent.defaultValue"
                    ></v-text-field>
                </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="component.controlName === 'errorBar'">
      <div class="error-bar" v-if="component.show">{{component.displayName}}</div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import yAddListItem from '../components/yAddListItem.vue'
import yFileUploader from '../components/yFileUploader.vue'
import { subbrandToolHelper } from '../mixins/subbrandToolHelper'
export default {
  name: 'conditional-render',
  inject: ['$validator'],
  mixins: [subbrandToolHelper],
  props: {
    dataProps: Object
  },
  data() {
    return {}
  },
  components: {
    yAddListItem: yAddListItem,
    yFileUploaderDev: yFileUploader,
    yFileUploaderProd: yFileUploader
  },
  computed: {
    component() {
      return this.dataProps
    },
    displayName() {
      return this.dataProps.displayName
    },
    isCDVEnabled() {
      var showMsg = false
      if (this.dataProps.formData && this.dataProps.formData.length) {
        this.dataProps.formData.forEach(childComp => {
          if (
            childComp.sdpValue == 'Matching_Services' &&
            childComp.defaultValue == true
          ) {
            showMsg = true
          }
        })
        return showMsg
      }
    }
  },
  methods: {
    addAnotherContact() {
      console.log('Another contact')
      console.log(
        'Currently selected page--->',
        this.$store.state.createSubbrandStore.selectedForm
      )
      let contactForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= contactForms.length - 1; i++) {
        if (contactForms[i].refId && contactForms[i].refId == 'contact2') {
          contactForms[i].show = true
        }
        if (
          contactForms[i].refId &&
          contactForms[i].refId == 'addAnotherContactBtn'
        ) {
          contactForms[i].disabled = true
        }
      }
    },
    addAnotherJWT() {
      console.log('Another JWT')
      let jwtForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= jwtForms.length - 1; i++) {
        if (
          (jwtForms[i].refId && jwtForms[i].refId == 'jwt2') ||
          (jwtForms[i].refId && jwtForms[i].refId == 'jwtprod2')
        ) {
          jwtForms[i].show = true
          jwtForms[i].inlineIconBtn.show = true
        }
        if (
          (jwtForms[i].refId && jwtForms[i].refId == 'addAnotherJWTBtn') ||
          (jwtForms[i].refId && jwtForms[i].refId == 'addAnotherProdJWT')
        ) {
          jwtForms[i].disabled = true
        }
      }
    },
    deleteContact() {
      console.log('Delete contact')
      console.log(
        'Currently selected page--->',
        this.$store.state.createSubbrandStore.selectedForm
      )
      let contactForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= contactForms.length - 1; i++) {
        if (contactForms[i].refId && contactForms[i].refId == 'contact2') {
          contactForms[i].show = false
          contactForms[i].formData.forEach(formData => {
            formData.defaultValue = ''
            if (formData.refId === 'resetUserIdPwd1') {
              formData.show = false
              formData.defaultValue = false
            }
          })
        }
        if (
          contactForms[i].refId &&
          contactForms[i].refId == 'addAnotherContactBtn'
        ) {
          contactForms[i].disabled = false
        }
      }
    },
    deleteJWT() {
      console.log('Delete jwt')
      let jwtForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= jwtForms.length - 1; i++) {
        if (
          (jwtForms[i].refId && jwtForms[i].refId == 'jwt2') ||
          (jwtForms[i].refId && jwtForms[i].refId == 'jwtprod2')
        ) {
          jwtForms[i].show = false

          jwtForms[i].formData.forEach(formData => {
            if (formData.defaultValue !== '') {
              if (
                formData.refId !== 'jwtAlgorithm' &&
                formData.refId !== 'jwtAlgorithm1'
              ) {
                formData.defaultValue = ''
              }
            }
          })
        }
        if (
          (jwtForms[i].refId && jwtForms[i].refId == 'addAnotherJWTBtn') ||
          (jwtForms[i].refId && jwtForms[i].refId == 'addAnotherProdJWT')
        ) {
          jwtForms[i].disabled = false
        }
      }
    },
    deleteJWTIssuerId() {
      console.log('Delete issuer id')
      let jwtShowForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= jwtShowForms.length - 1; i++) {
        if (jwtShowForms[i].refId && jwtShowForms[i].refId == 'jwt') {
          jwtShowForms[i].formData.forEach(formData => {
            if (
              formData.refId == 'jwtIssuerId' &&
              formData.defaultValue !== ''
            ) {
              formData.defaultValue = ''
              formData.show = false
            } else {
              formData.show = true
            }
          })
        }
      }
    },
    deleteJWTIssuerId1() {
      console.log('Delete issuer id 1')
      let jwtShowForms = this.$store.state.createSubbrandStore.selectedForm
      for (let j = 0; j <= jwtShowForms.length - 1; j++) {
        if (jwtShowForms[j].refId && jwtShowForms[j].refId == 'jwt2') {
          jwtShowForms[j].inlineIconBtn.show = true
          jwtShowForms[j].formData.forEach(formData => {
            if (
              formData.refId == 'jwtIssuerId1' &&
              formData.defaultValue !== ''
            ) {
              formData.defaultValue = ''
              formData.show = false
            } else {
              formData.show = true
            }
          })
        }
      }
    },
    deleteProdJWTIssuerId() {
      console.log('Delete prod issuer id')
      let jwtShowForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= jwtShowForms.length - 1; i++) {
        if (jwtShowForms[i].refId && jwtShowForms[i].refId == 'jwt') {
          jwtShowForms[i].formData.forEach(formData => {
            if (
              formData.refId == 'jwtProdIssuerId' &&
              formData.defaultValue !== ''
            ) {
              formData.defaultValue = ''
              formData.show = false
            } else {
              formData.show = true
            }
          })
        }
      }
    },
    deleteProdJWTIssuerId1() {
      console.log('Delete prod1 issuer id')
      let jwtShowForms = this.$store.state.createSubbrandStore.selectedForm
      for (let i = 0; i <= jwtShowForms.length - 1; i++) {
        if (jwtShowForms[i].refId && jwtShowForms[i].refId == 'jwtprod2') {
          jwtShowForms[i].inlineIconBtn.show = true
          jwtShowForms[i].formData.forEach(formData => {
            if (
              formData.refId == 'jwtProdIssuerId1' &&
              formData.defaultValue !== ''
            ) {
              formData.defaultValue = ''
              formData.show = false
            } else {
              formData.show = true
            }
          })
        }
      }
    },
    updateComponent(componentData) {
      var self = this
      var currentStep = this.$store.state.createSubbrandStore.currentStep
      let templateData = this.$store.state.createSubbrandStore
        .createTemplateData
      let content = templateData.content[currentStep]
      // Updating the Auth Setup data on selection
      if (
        componentData.refId &&
        (componentData.refId == 'stageAuthType' ||
          componentData.refId == 'prodAuthType') &&
        content
      ) {
        let selectedAuthType = componentData.defaultValue
        let formData = content.form
        for (let j = 0; j <= formData.length - 1; j++) {
          if (formData[j].controlName == 'formGroup') {
            if (selectedAuthType.indexOf(formData[j].refId) >= 0) {
              formData[j].show = true
              if (formData[j].refId == 'jwt') {
                this.$store.state.createSubbrandStore.showAddAnotherJWTBtn = true
                this.$store.state.createSubbrandStore.showAnotherJWT2Form = true
              }
              if (formData[j].refId == 'saml') {
                let samlCertdev = _.findWhere(formData[j].formData, {
                  refId: 'samlCertdev'
                })
                if (samlCertdev) {
                  samlCertdev.showError = false
                }

                let samlCertprod = _.findWhere(formData[j].formData, {
                  refId: 'samlCertprod'
                })
                if (samlCertprod) {
                  samlCertprod.showError = false
                }
              }
            } else {
              formData[j].show = false
              if (formData[j].refId == 'jwt') {
                this.$store.state.createSubbrandStore.showAddAnotherJWTBtn = false
                this.$store.state.createSubbrandStore.showAnotherJWT2Form = false
              }
            }
          }
          if (
            (formData[j].refId && formData[j].refId == 'addAnotherJWTBtn') ||
            (formData[j].refId && formData[j].refId == 'addAnotherProdJWT')
          ) {
            formData[
              j
            ].show = this.$store.state.createSubbrandStore.showAddAnotherJWTBtn
          }

          if (
            (formData[j].controlName == 'formGroup' &&
              formData[j].refId == 'jwt2') ||
            (formData[j].controlName == 'formGroup' &&
              formData[j].refId == 'jwtprod2')
          ) {
            formData[j].formData.forEach(formDataObj => {
              if (this.$store.state.createSubbrandStore.showAnotherJWT2Form) {
                if (formDataObj.defaultValue !== '') {
                  self.$store.state.createSubbrandStore.disableAddAnotherJWTBtn = true
                  formData[j].show = true
                } else {
                  self.$store.state.createSubbrandStore.disableAddAnotherJWTBtn = false
                  formData[j].show = false
                }
              }
            })
          }

          if (
            (formData[j].refId && formData[j].refId == 'addAnotherJWTBtn') ||
            (formData[j].refId && formData[j].refId == 'addAnotherProdJWT')
          ) {
            formData[j].disabled =
              self.$store.state.createSubbrandStore.disableAddAnotherJWTBtn
          }
        }
      }
    },
    updateChannelComponent(componentData) {
      var self = this
      let templateData = this.$store.state.channelStore.channelFormData
      let formContent = templateData.content[0].form
      // Updating the Auth Setup data on selection
      if (
        componentData.refId &&
        componentData.refId == 'stageAuthType' &&
        formContent
      ) {
        let prodAuthType = _.findWhere(formContent, {
          refId: 'prodAuthType'
        })
        prodAuthType.defaultValue = componentData.defaultValue
        
        let selectedAuthType = componentData.defaultValue
        for (let j = 0; j <= formContent.length - 1; j++) {
          if (formContent[j].controlName == 'formGroup') {
            if (selectedAuthType.indexOf(formContent[j].refId) >= 0) {
              formContent[j].show = true
            } else {
              formContent[j].show = false
            }
          }
        }
      }
    },
    resetPassword(e) {
      let resetForm = this.$store.state.createSubbrandStore.selectedForm
      let resetDevPwd = _(
        _(resetForm).findWhere({ refId: 'saml' }).formData
      ).findWhere({ refId: 'resetDevPwd' })
      let resetProdPwd = _(
        _(resetForm).findWhere({ refId: 'saml' }).formData
      ).findWhere({ refId: 'resetProdPwd' })
      if (resetDevPwd) {
        resetDevPwd.defaultValue = true
      } else if (resetProdPwd) {
        resetProdPwd.defaultValue = true
      }
    },
    resetUserIdPassword(e) {
      let resetForm = this.$store.state.createSubbrandStore.selectedForm
      let resetUserPwd = _(
        _(resetForm).findWhere({ refId: 'contact1' }).formData
      ).findWhere({ refId: 'resetUserIdPwd' })
      if (resetUserPwd) {
        resetUserPwd.defaultValue = true
      }
    },
    resetUserIdPassword1(e) {
      let resetForm = this.$store.state.createSubbrandStore.selectedForm
      let resetUserPwd1 = _(
        _(resetForm).findWhere({ refId: 'contact2' }).formData
      ).findWhere({ refId: 'resetUserIdPwd1' })
      if (resetUserPwd1) {
        resetUserPwd1.defaultValue = true
      }
    },
    isInputDisabled(component) {
      let resetForm = this.$store.state.createSubbrandStore.selectedForm
      var currentStep = this.$store.state.createSubbrandStore.currentStep
      let templateData = this.$store.state.createSubbrandStore
        .createTemplateData

      if (component.disabled) {
        return true
      } else {
        if (this.isEditFlow && component.editFlowDisabled) {
          if (component.refId === 'devLoginId') {
            return this.devSamlLogin(resetForm)
          } else if (component.refId === 'prodLoginId') {
            return this.prodSamlLogin(resetForm)
          } else if (component.refId === 'cUserId') {
            return this.contactId(resetForm)
          } else if (component.refId === 'cUserId1') {
            return this.contactId1(resetForm)
          } else {
            return true
          }
        }
      }
    },
    isResetVisible(component) {
      let resetForm = this.$store.state.createSubbrandStore.selectedForm
      var currentStep = this.$store.state.createSubbrandStore.currentStep
      let templateData = this.$store.state.createSubbrandStore
        .createTemplateData

      if (component.refId === 'resetDevPwd') {
        return this.devSamlLogin(resetForm)
      } else if (component.refId === 'resetProdPwd') {
        return this.prodSamlLogin(resetForm)
      } else if (component.refId === 'resetUserIdPwd') {
        return this.contactId(resetForm)
      } else if (component.refId === 'resetUserIdPwd1') {
        return this.contactId1(resetForm)
      }
    },
    devSamlLogin(resetForm) {
      let devSaml, displayDevResetPwd

      devSaml = _.findWhere(resetForm, {
        refId: 'saml'
      })
      if (devSaml) {
        displayDevResetPwd = _(
          _(resetForm).findWhere({ refId: 'saml' }).formData
        ).findWhere({ refId: 'devPwd' })
        return displayDevResetPwd.defaultValue ? true : false
      }
    },
    prodSamlLogin(resetForm) {
      let prodSaml, displayProdResetPwd

      prodSaml = _.findWhere(resetForm, {
        refId: 'saml'
      })
      if (prodSaml) {
        displayProdResetPwd = _(
          _(resetForm).findWhere({ refId: 'saml' }).formData
        ).findWhere({ refId: 'prodPwd' })
        return displayProdResetPwd.defaultValue ? true : false
      }
    },
    contactId(resetForm) {
      let cUserIdPwd

      cUserIdPwd = _(
        _(resetForm).findWhere({ refId: 'contact1' }).formData
      ).findWhere({ refId: 'cUserIdPwd' })

      if (cUserIdPwd) {
        return cUserIdPwd.defaultValue ? true : false
      }
    },
    contactId1(resetForm) {
      let cUserIdPwd1

      cUserIdPwd1 = _(
        _(resetForm).findWhere({ refId: 'contact2' }).formData
      ).findWhere({ refId: 'cUserIdPwd1' })

      if (cUserIdPwd1) {
        return cUserIdPwd1.defaultValue ? true : false
      }
    },
    showHintText(component) {
      if (this.isInputDisabled(component) === true) {
        return (component.hintText = '')
      } else {
        return component.hintText
      }
    }
  }
}
</script>

<style lang="scss">
.hint-text {
  font-size: 12px;
  display: block;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
}
.error-bar {
  float: none;
  clear: both;
  font-size: 14px;
  margin-bottom: 16px;
  color: #dc3828;
}
</style>

